


















import Loading from '@/components/pages/common/Loading.vue'
export default
  name: 'CompleteDialog'

  components: {
    Loading
  }
  props:
    dialog: {
      type: Boolean
      required: true
    }
    loading: {
      type: Boolean
      required: false
      default: false
    }
    titleMsg:{
      type: String
      required: false
    }
    msg: {
      type: String
      required: true
    }
  computed:
    titleTxt:()->
      txt = @titleMsg
      return txt
  methods:
    onClose: () ->
      this.$emit('close', 'complete')



// WEBPACK FOOTER //
// ./src/packages/dialogs/Complete.vue